import { Typography } from '@mui/material';
import type { CoverageDto } from '../../../../../../../../types';
import { formatCurrencyToTenthsPlaceWithUnit } from '../../../../../../../../utils/currency.utils';
import CoverageCheckbox from '../../../../../../../agencies/quotes/PrimeX/customizeQuote/components/CoverageCheckbox';
import { RETROACTIVE_PERIODS } from '../../helpers/coverage-summary.utils';
import { CoverageGridCell, DeltaGridCell } from '../CoverageGridCell';

interface CoverageDetailsProps {
  mergedCoverage: any;
  isOdd: boolean;
}

export const CoverageRow = ({
  mergedCoverage,
  isOdd,
}: CoverageDetailsProps) => {
  if (!mergedCoverage) {
    return null;
  }

  return (
    <>
      <DeltaGridCell
        item
        md={4}
        sx={{ padding: '1rem' }}
        isDelta={mergedCoverage.isDelta}
        isOdd={isOdd}
      >
        <Typography variant="caption">
          {mergedCoverage.endorsement?.coverageFullName ||
            mergedCoverage.policy?.coverageFullName}
        </Typography>
      </DeltaGridCell>
      <CoverageGridCell item md={1} isOdd={isOdd}>
        {getCheckBoxIcon(mergedCoverage.policy)}
      </CoverageGridCell>

      <CoverageDetails
        coverage={mergedCoverage?.policy || mergedCoverage.endorsement}
        isOdd={isOdd}
      />

      <CoverageGridCell item md={1} isOdd={isOdd}>
        {getCheckBoxIcon(mergedCoverage.endorsement)}
      </CoverageGridCell>

      <CoverageDetails
        coverage={mergedCoverage?.endorsement || mergedCoverage?.policy}
        isOdd={isOdd}
      />
    </>
  );
};

const CoverageDetails = ({
  coverage,
  isOdd,
}: {
  coverage: CoverageDto;
  isOdd: boolean;
}) => {
  if (!coverage) {
    return null;
  }

  return (
    <>
      <CoverageGridCell item md={1} isOdd={isOdd}>
        <Typography variant="caption">
          {formatCurrencyToTenthsPlaceWithUnit(coverage.limit as number)}
        </Typography>
      </CoverageGridCell>

      <CoverageGridCell item md={1} isOdd={isOdd}>
        <Typography variant="caption">
          {formatCurrencyToTenthsPlaceWithUnit(coverage.deductible as number)}
        </Typography>
      </CoverageGridCell>

      <CoverageGridCell item md={1} isOdd={isOdd}>
        <Typography variant="caption">
          {RETROACTIVE_PERIODS[
            coverage.retroActivePeriod as keyof typeof RETROACTIVE_PERIODS
          ] || '-'}
        </Typography>
      </CoverageGridCell>
    </>
  );
};

const getCheckBoxIcon = (coverage: CoverageDto | null) => {
  if (!coverage) {
    return <CoverageCheckbox.Available disabled label="" />;
  }

  if (coverage.isMandatory) {
    return <CoverageCheckbox.Mandatory label="" />;
  }

  return <CoverageCheckbox.Selected disabled label="" />;
};
